export default function TotalAmountIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect
        x="2.33337"
        y="4.66663"
        width="23.3333"
        height="18.6667"
        rx="4"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M16.3333 11.6667C16.3333 10.378 15.2886 9.33333 14 9.33333C12.7113 9.33333 11.6666 10.378 11.6666 11.6667C11.6666 12.9553 12.7113 14 14 14"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M14 14C15.2886 14 16.3333 15.0446 16.3333 16.3333C16.3333 17.622 15.2886 18.6666 14 18.6666C12.7113 18.6666 11.6666 17.622 11.6666 16.3333"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M14 7.58337V9.33337"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 18.6666V20.4166"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
